<template>
  <div class="board">
    <div class="py-6 px-8">
      <h-header>
        <template v-slot:changes>
          <BoardViewChange />
        </template>
        <template v-slot:actions>
          <div class="d-flex justify-end">
            <v-btn
              @click="openCreateAppointmentModal"
              color="primary"
              elevation="0"
            >
              <v-icon left>mdi-plus</v-icon>
              <span class="d-none d-md-flex body-2">
                {{ $t(`create.label.appointment`) }}
              </span>
            </v-btn>
            <v-btn
              @click="openModal('BATCH_SCHEDULE_MODAL')"
              color="primary"
              elevation="0"
              class="ml-3"
            >
              <v-icon small> mdi-upload </v-icon>
            </v-btn>
          </div>
        </template>
      </h-header>
      <BoardListFilters />

      <BoardListView v-if="boardDensity === 'LIST'" :board="filteredBoard" />
      <BoardColumnView v-else :board="filteredBoard" />
    </div>

    <RightDrawer :moreInfo="false">
      <AppointmentVisualization />
    </RightDrawer>

    <ModalBatchSchedule />
    <MenuAppointmentModals @refreshAppointments="refreshAppointments" :selectedAppointments="selectedAppointments" :isAdmin="false" />
  </div>
</template>

<script>
import BoardListFilters from '@/components/board/BoardListFilters'
import BoardViewChange from '@/components/board/BoardViewChange'
import BoardColumnView from '@/components/board/BoardColumnView'
import BoardListView from '@/components/board/BoardListView'
import AppointmentCreate from '@/components/appointment/AppointmentCreate'

import RightDrawer from '@/components/app/RightDrawer'
import AppointmentCancel from '@/components/appointment/AppointmentCancel'
import AppointmentReschedule from '@/components/appointment/AppointmentReschedule'
import AppointmentVisualization from '@/components/appointment/AppointmentVisualization'
import { mapGetters, mapActions } from 'vuex'

import ModalBatchSchedule from '@/components/appointment/modals/ModalBatchSchedule'
import MenuAppointment from '@/components/appointment/MenuAppointment'
import MenuAppointmentModals from '@/components/appointment/MenuAppointmentModals'

export default {
  name: 'Board',

  components: {
    AppointmentCreate,
    BoardListFilters,
    BoardViewChange,
    BoardColumnView,
    BoardListView,
    RightDrawer,
    AppointmentCancel,
    AppointmentReschedule,
    AppointmentVisualization,
    ModalBatchSchedule,
    MenuAppointmentModals,
    MenuAppointment,
  },

  computed: {
    ...mapGetters(['filteredBoard', 'boardDensity', 'activeModal']),
  },

  methods: {
    ...mapActions(['fetchBoard', 'openModal']),

    openCreateAppointmentModal() {
      const modal = this.$root.$children[0].$refs?.createAppointmentModal?.$refs?.createModal
      modal.dialog = true
    },

    refreshAppointments() {
      this.fetchBoard()
    },
  },

  data() {
    return {
      selectedAppointments: [],
    }
  },

  mounted() {
    this.fetchBoard()
  },
}
</script>
